import { FeatureState, isFeatureEnabled } from '@etrigan/feature-toggles-client'
import { Features } from '@news-mono/web-common'

interface BauhausArticle {
    id: string
    feature: Features | undefined
}

export function isBauhausArticle(
    topic: string,
    toggles: FeatureState,
): boolean {
    const bauhausArticles: BauhausArticle[] = [
        {
            id: 'entertainment/big-brother-australia',
            feature: '7ent-article-layout',
        },
        {
            id: 'lifestyle',
            feature: '7-news-lifestyle-article-full-page-display',
        },
        {
            id: 'travel',
            feature: '7-news-lifestyle-article-full-page-display',
        },
        {
            id: 'entertainment/dancing-with-the-stars',
            feature: '7news-dwts-full-article-page-display',
        },
        {
            id: 'entertainment/sas-australia',
            feature: '7-news-sas-australia-article-full-page-display',
        },
        {
            id: 'sport',
            feature: '7-news-sport-article-full-page-display',
        },
        {
            id: 'politics',
            feature: '7-news-politics-full-page-article-display',
        },
        {
            id: 'entertainment',
            feature: '7-entertainment-article-full-page-display',
        },
        {
            id: 'sunrise',
            feature: '7-entertainment-sunrise-full-article-display',
        },
        {
            id: 'the-morning-show',
            feature: '7-entertainment-the-morning-show-full-article-display',
        },
        {
            id: 'business',
            feature: '7-news-finance-business-full-article-display',
        },
        {
            id: 'technology',
            feature: '7-news-tech-full-article-page-display',
        },
        {
            id: 'news/world',
            feature: '7-news-world-full-article-page-display',
        },
        { id: 'news', feature: '7-news-article-full-page-display' },
        {
            id: 'weather',
            feature: '7-news-weather-full-article-page-display',
        },
        {
            id: 'spotlight',
            feature: '7-news-spotlight-full-article-display',
        },
        {
            id: 'heartbreak-island',
            feature: '7-news-heartbreak-full-article-page-display',
        },
        {
            id: 'whats-for-dinner',
            feature: '7-news-wfd-full-article-page-display',
        },
        {
            id: 'farmer-wants-a-wife',
            feature: undefined,
        },
        {
            id: 'kitchen-nightmares-australia',
            feature: undefined,
        },
        {
            id: 'agt',
            feature: '7-news-agt-full-article-page-display',
        },
        {
            id: 'wcs',
            feature: undefined,
        },
        {
            id: 'australian-idol',
            feature: undefined,
        },
    ]

    const isBauhausArticle = bauhausArticles.find((item) =>
        topic.includes(item.id),
    )
    if (!isBauhausArticle) {
        return false
    }
    if (!isBauhausArticle.feature) {
        return true
    }
    const isBauhausArticleFeatureEnabled = isFeatureEnabled(
        toggles,
        isBauhausArticle.feature,
    )
    return isBauhausArticleFeatureEnabled
}

export function isBauhausSidebar(
    toggles: FeatureState,
    pathName?: string,
): boolean {
    const bauhausArticles: BauhausArticle[] = [
        {
            id: 'lifestyle',
            feature: '7-news-lifestyle-right-hand-side-the-latest',
        },
        {
            id: 'travel',
            feature: '7-news-lifestyle-right-hand-side-the-latest',
        },
        {
            id: 'entertainment',
            feature: 'entertainment-trending',
        },
        {
            id: 'sport',
            feature: '7-news-sport-article-full-page-display',
        },
        {
            id: 'politics',
            feature: '7-news-politics-full-page-article-display',
        },
        {
            id: 'sunrise',
            feature: '7-entertainment-sunrise-full-article-display',
        },
        {
            id: 'the-morning-show',
            feature: '7-entertainment-the-morning-show-full-article-display',
        },
        {
            id: 'technology',
            feature: '7-news-tech-full-article-page-display',
        },
        {
            id: 'news',
            feature: '7-news-article-full-page-display',
        },
        {
            id: 'world',
            feature: '7-news-world-full-article-page-display',
        },
        {
            id: 'business',
            feature: '7-news-finance-business-full-article-display',
        },
        {
            id: 'weather',
            feature: '7-news-weather-full-article-page-display',
        },
        {
            id: 'spotlight',
            feature: '7-news-spotlight-full-article-display',
        },
        {
            id: 'heartbreak-island',
            feature: '7-news-heartbreak-full-article-page-display',
        },
        {
            id: 'whats-for-dinner',
            feature: '7-news-wfd-full-article-page-display',
        },
        {
            id: 'farmer-wants-a-wife',
            feature: undefined,
        },
        {
            id: 'kitchen-nightmares-australia',
            feature: undefined,
        },
        {
            id: 'agt',
            feature: '7-news-agt-full-article-page-display',
        },
        {
            id: 'wcs',
            feature: undefined,
        },
        {
            id: 'australian-idol',
            feature: undefined,
        },
    ]
    if (!pathName) {
        return false
    }
    if (pathName.includes('contact-us')) {
        return true
    }
    if (pathName.includes('spotthebucket')) {
        return true
    }
    const isBauhausArticle = bauhausArticles.find((item) =>
        pathName.includes(item.id),
    )
    if (!isBauhausArticle) {
        return false
    }
    if (!isBauhausArticle.feature) {
        return true
    }
    const isBauhausArticleFeatureEnabled = isFeatureEnabled(
        toggles,
        isBauhausArticle.feature,
    )
    return isBauhausArticleFeatureEnabled
}

export interface SevenPlusButtonArticles {
    id: string
    feature?: string
    url: string
}

export function getSevenPlusArticleButtonLink(
    topic: string,
    toggles: FeatureState,
): { isEnabled: boolean; buttonLink?: string } {
    const includedArticles: SevenPlusButtonArticles[] = [
        {
            id: 'entertainment/sas-australia',
            url: 'https://7plus.com.au/sas-australia?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=sas-australia',
        },
        {
            id: 'entertainment/dancing-with-the-stars',
            url: 'https://7plus.com.au/dancing-with-the-stars-all-stars?utm_source=7NEWS&utm_medium=footer-button&utm_campaign=DWTS',
        },
        {
            id: 'entertainment/home-and-away',
            url: 'https://7plus.com.au/home-and-away?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=home-and-away',
        },
        {
            id: 'entertainment/the-voice-australia',
            url: 'https://7plus.com.au/the-voice?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=the-voice',
        },
        {
            id: 'entertainment/big-brother-australia',
            url: 'https://7plus.com.au/big-brother?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=big-brother',
        },
        {
            id: 'entertainment/farmer-wants-a-wife',
            url: 'https://7plus.com.au/farmer-wants-a-wife?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=/farmer-wants-a-wife',
        },
        {
            id: 'entertainment/kitchen-nightmares-australia',
            url: 'https://7plus.com.au/kitchen-nightmares-australia?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=kitchen-nightmares-australia',
        },
        {
            id: 'entertainment/agt',
            url: 'https://7plus.com.au/australias-got-talent?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=australias-got-talent',
        },
        {
            id: 'sport/wcs',
            url: 'https://7plus.com.au/sport?utm_source=7NEWS&utm_medium=hero-card-show-page&utm_campaign=fifa-world-cup-2022',
        },
        {
            id: 'entertainment/australian-idol',
            url: 'https://7plus.com.au/australian-idol?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=australian-idol',
        },
        {
            id: 'entertainment/heartbreak-island',
            url: 'https://7plus.com.au/heartbreak-island-australia?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=heartbreak-island-aus',
        },
        {
            id: 'entertainment/my-kitchen-rules',
            url: 'https://7plus.com.au/my-kitchen-rules?utm_source=7NEWS&utm_medium=stream-free-button&utm_campaign=mkr-article-page',
        },
        {
            id: 'entertainment/farmer-wants-a-wife',
            url: 'https://7plus.com.au/farmer-wants-a-wife?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=farmer-wants-a-wife',
        },
        {
            id: 'sport/aflw',
            url: 'https://7plus.com.au/aflw?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=aflw-article',
        },
        {
            id: 'sport/afl',
            url: 'https://7plus.com.au/afl?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=afl-article',
        },
        {
            id: 'sport/commonwealth-games',
            url: 'https://7plus.com.au/commonwealth-games?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=comm-games-2022',
        },
        {
            id: 'sport/cricket',
            url: 'https://7plus.com.au/7-cricket?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=cricket',
        },
        {
            id: 'sport/surfing',
            url: 'https://7plus.com.au/surfing?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=surfing',
        },
        {
            id: 'sport/motorsport',
            url: ' https://7plus.com.au/motorsport?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=motorsport',
        },
        {
            id: 'sport/horse-racing',
            url: 'https://7plus.com.au/horse-racing?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=horse-racing',
        },
        {
            id: 'sport/nfl',
            url: 'https://7plus.com.au/nfl?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=nfl',
        },

        {
            id: 'sport',
            url: 'https://7plus.com.au/sport?utm_source=7NEWS&utm_medium=bottom-7plus-button&utm_campaign=sport-article',
        },

        {
            id: 'sunrise',
            url: 'https://7plus.com.au/sunrise?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=sunrise-articles',
        },
        {
            id: 'entertainment',
            url: 'https://7plus.com.au/shows?utm_source=7NEWS&utm_medium=stream-free-bottom-article-button&utm_campaign=entertainment-articles',
        },
        {
            id: 'the-morning-show',
            url: 'https://7plus.com.au/the-morning-show?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=the-morning-show-articles',
        },
        {
            id: 'technology',
            url: 'https://7plus.com.au/news?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=tech-articles',
        },
        {
            id: 'news/world',
            url: 'https://7plus.com.au/news?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=world-articles',
        },
        {
            id: 'news',
            url: 'https://7plus.com.au/news?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=news-articles',
        },
        {
            id: 'business',
            url: 'https://7plus.com.au/news?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=business-articles',
        },
        {
            id: 'weather',
            url: 'https://7plus.com.au/news?utm_source=7NEWS&utm_medium=end-of-article-button&utm_campaign=weather-articles',
        },
        {
            id: 'spotlight',
            url: 'https://7plus.com.au/7news-spotlight?utm_source=7NEWS&utm_medium=7plus-footer-button&utm_campaign=spotlight-article-page',
        },
    ]
    const data = includedArticles.find((item) => topic.includes(item.id))
    if (!data) {
        return { isEnabled: false }
    }
    return {
        isEnabled: true,
        buttonLink: data.url,
    }
}
export interface SubTopicData {
    trendingTitle: string
    trendingCuration: string
    promoCardsCuration: string
    //Some topics (eg. Technology) is listing instead of curation
    //Without flag in that situation subtopic page will crash
    isListingTopic?: boolean
}
interface BauhausSubtopic {
    id: string
    feature: Features
    subtopicData: SubTopicData
}

export function getBauhausSubtopicPageData(
    topic: string,
    toggles: FeatureState,
): { isEnabled: false } | { isEnabled: true; data: SubTopicData } {
    const bauhausSubTopic: BauhausSubtopic[] = [
        {
            id: 'lifestyle',
            feature: '7-news-lifestyle-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'The Latest',
                trendingCuration: 'lifestyle',
                promoCardsCuration: '7news-lifestyle-promo-cards',
            },
        },
        {
            id: 'travel',
            feature: '7-news-lifestyle-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'The Latest',
                trendingCuration: 'lifestyle',
                promoCardsCuration: '7news-lifestyle-promo-cards',
            },
        },
        {
            id: 'entertainment',
            feature: '7-news-entertainment-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'entertainment',
                promoCardsCuration: '7news-entertainment-promo-cards',
            },
        },
        {
            id: 'sunrise',
            feature: '7-news-entertainment-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'entertainment',
                promoCardsCuration: '7news-entertainment-promo-cards',
            },
        },
        {
            id: 'the-morning-show',
            feature: '7-news-entertainment-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'entertainment',
                promoCardsCuration: '7news-entertainment-promo-cards',
            },
        },
        {
            id: 'politics',
            feature: '7-news-politics-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'politics',
                promoCardsCuration: '7news-politics-promo-cards',
            },
        },
        {
            id: 'sport',
            feature: '7-news-sport-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Latest in sport',
                trendingCuration: 'sport',
                promoCardsCuration: 'sport-promo-cards',
            },
        },
        {
            id: 'technology',
            feature: '7-news-tech-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'technology',
                promoCardsCuration: '7news-tech-promo-cards',
                isListingTopic: true,
            },
        },
        {
            id: 'weather/',
            feature: '7-news-weather-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'weather',
                promoCardsCuration: '7news-weather-promo-cards',
                isListingTopic: true,
            },
        },
        {
            id: 'business',
            feature: '7-news-business-sub-topic-page',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'business/finance',
                promoCardsCuration: '7news-finance-promo-cards',
                isListingTopic: true,
            },
        },
        {
            id: 'news',
            feature: '7-news-sub-topic-page-display',
            subtopicData: {
                trendingTitle: 'Trending',
                trendingCuration: 'news',
                promoCardsCuration: '7news-home-promo-cards',
                isListingTopic: true,
            },
        },
    ]

    const topicData = bauhausSubTopic.find((item) => topic.includes(item.id))

    if (!topicData) {
        return { isEnabled: false }
    }

    const isBauhausSubtopicFeatureEnabled = isFeatureEnabled(
        toggles,
        topicData.feature,
    )

    return {
        isEnabled: isBauhausSubtopicFeatureEnabled,
        data: topicData.subtopicData,
    }
}
